<template>
  <DefaultSection class="section is-title-only">
    <div class="container">
      <h2 class="title is-size-medium has-text-centered has-text-weight-bold">
        {{ title }}
      </h2>
    </div>
  </DefaultSection>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: '',
  },
})

defineBlokkli({
  bundle: 'title_centered',
})
</script>
